import * as yup from "yup";

export const schema = yup.object().shape({
    statusId: yup
        .object()
        .required(),
    comments: yup
        .string()
        .max(10000),
});